export default __webpack_public_path__ + "static/media/ic_attendance.e2fa79ef.svg";